import { render } from "./BaseTrigger.vue?vue&type=template&id=36e32b62"
import script from "./BaseTrigger.vue?vue&type=script&lang=js"
export * from "./BaseTrigger.vue?vue&type=script&lang=js"

import "./BaseTrigger.vue?vue&type=style&index=0&id=36e32b62&lang=scss"
script.render = render

export default script